import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { authRoutes } from "./routes/authRoutes";
import { legalRoutes } from "./routes/legalRoutes";
import { protectedRoutes } from "./routes/protectedRoutes";

// Loading fallback component
const LoadingFallback = () => <div className="p-4">Loading...</div>;

// Routes Component - no longer includes BrowserRouter which is moved to App.tsx
export function AppRoutes() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Auth Routes */}
        {authRoutes}

        {/* Legal Pages - Public Routes */}
        {legalRoutes}

        {/* Protected Routes */}
        {protectedRoutes}

        {/* 404 Route */}
        <Route path="*" element={<div>404 - Not Found</div>} />
      </Routes>
    </Suspense>
  );
}
